export const imageTypes = ['png', 'jpg', 'jpeg', 'webp', 'gif']
